import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// Define our single API slice object
export const apiSlice = createApi({
  // The cache reducer expects to be added at `state.api` (already default - this is optional)
  reducerPath: 'api',
  // All of our requests will have URLs starting with '/fakeApi'
  baseQuery: fetchBaseQuery({ baseUrl: 'https://my-api.grutatest.workers.dev' }),
  // The "endpoints" represent operations and requests for this server
  endpoints: (builder) => ({
    // The `getPosts` endpoint is a "query" operation that returns data
    getHolders: builder.query({
      query: () => '/holders',
    }),
    getInfoHero: builder.query({
      query: () => '/epicHero/getInfo',
    }),
    getEHStats: builder.query({
      query: () => '/epicHero/stats',
    }),
    getInfoBattles: builder.query({
      query: () => '/epicHero/getBattles',
    }),
    getXLibero: builder.query({
      query: () => '/xlibero',
    }),
    getXLibera: builder.query({
      query: () => '/xlibera',
    }),
  }),
});

// Export the auto-generated hook for the `getPosts` query endpoint
export const {
  useGetHoldersQuery, useGetInfoHeroQuery, useGetInfoBattlesQuery, useGetXLiberoQuery, useGetXLiberaQuery, useGetEHStatsQuery,
} = apiSlice;
